import catmullRom from "./catmullRom";
export default function drawSpline(ctx, stroke) {
    const { points, style } = stroke;
    if (points.length < 4) {
        return;
    }
    ctx.save();
    ctx.strokeStyle = style.color;
    ctx.shadowColor = style.color;
    ctx.lineWidth = style.lineWidth;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.globalAlpha = style.opacity;
    ctx.shadowBlur = 0.2;
    ctx.beginPath();
    ctx.moveTo(points[0].x + style.offsetX, points[0].y + style.offsetY);
    for (let i = 0; i < points.length - 1; i++) {
        const p0 = points[Math.max(0, i - 1)];
        const p1 = points[i];
        const p2 = points[i + 1];
        const p3 = points[Math.min(points.length - 1, i + 2)];
        for (let step = 1; step <= 10; step++) {
            const t = step / 10;
            const x = catmullRom(p0.x, p1.x, p2.x, p3.x, t) + style.offsetX;
            const y = catmullRom(p0.y, p1.y, p2.y, p3.y, t) + style.offsetY;
            ctx.lineTo(x, y);
        }
    }
    ctx.stroke();
    ctx.restore();
}
